const ua = window.navigator.userAgent;

export const isIOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
